
import { Button } from './buttons';
import { CardContainer } from "./card";
import { BtnClose, Error } from "../styles/icons/icons";
import { ToastType } from 'react-hot-toast';
import Constants from '../../utils/Constants';

interface ToastCardProps {
    message: string;
    type: ToastType;
    handleDismiss: () => void;
}

function ToastCard({message, type, handleDismiss}: ToastCardProps) {

  return(
    <div className='modal-bottom'>
      <CardContainer theme="outline" className="bg-white modal-content">
        <Button  className="w-full text-right mb-1 leading-0 p-0 bg-none border-0 outline-none h-auto leading-0">
          <span onClick={handleDismiss}><BtnClose/></span>
        </Button>
        <div className='d-flex gap-2 items-start'>
          <Button  className="p-0 bg-none border-0 outline-none h-auto leading-0"  >
            <Error />
          </Button>
          <div>
            <h4 className="mb-1 text-danger text-mdl">Error</h4>
            <p className="text-sm text-primaryBgColor leading-mdl">{message ? message : Constants.Instance.errorMessage}</p>
          </div>
        </div>
      </CardContainer>
  </div>
  )
}

export default ToastCard;